<!-- 需要传三个参数，一个是需要展示的数据源，二是绑定访视期，三是要绑定的字段 -->
<template>
  <div class="btn_fiexd">
     <el-upload
     action="#"
     multiple
     :show-file-list="false"
     :auto-upload="true" 
     :http-request="upload"
     >
     <el-button class="blue_btn" type="primary">{{btn_name}}</el-button>
     </el-upload>
     <div style="width: 300px;margin-top: 20px;">
       <el-progress :stroke-width="10" v-if="progressFlog" :percentage="loadProgress" />
     </div>
     <div class="demoimgs" v-if="arr_obj(images).length > 0">
         <div v-for="(item, index) in arr_obj(images)" :key="index" class="imgs">
           <!-- <img class="img" :src="item.url" :alt="item.name"> -->
           <p>{{  (item.name).replace(/(temp\/)[0-9]+-/g,'') }}</p>
           <p class="icons">
             <!-- 预览大图 -->
             <!-- <span @click="handlePictureCardPreview(item)">
               <el-icon class="icon"><zoom-in /></el-icon>
             </span> -->
             <!-- 下载 -->
             <span @click="downloadImage(item)">
               <el-icon class="icon"><Download /></el-icon>
             </span>
             <!-- 删除 -->
             <span @click="handleRemove(item,index)">
               <el-icon class="icon"><Delete /></el-icon>
             </span>
           </p>
         </div>
       
     </div>
   </div>
  
   <!-- 展示预览图 -->
   <!-- <el-dialog v-model="dialogVisible">
     <img class="Preview" :src="dialogImageUrl" alt="只支持图片预览" />
   </el-dialog> -->
 </template>
<script setup>
import {ref,reactive,computed} from 'vue'
import { useCommonStore } from '@/stores/common';
import { Delete, Download, Plus,ZoomIn } from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import  axios from "axios"

let progressFlog = ref(false)
let loadProgress = ref(0)
// const regName = (name)=>{
//   // let reg = /^(temp)[0-9]+/
//   let reg = /(temp\/)[0-9]+(-)/g

//   let a = name.replace(reg,'')
//   let b = 'temp/34534534534-sdlfjsldkjf3454-dfgsdgf'.replace(/(temp\/)[0-9]+-/g,'11')
//   let c = 'temp/345345-abcdef'.replace(/(temp\/)|a|b|c/g,0)
//   console.log(name,b,c)
//   // console.log(a)
//   return a
// }
// 图片上传的接口
const common = useCommonStore()
// const env = env;
const api_host = import.meta.env.VITE_APP_API_HOST;
const props = defineProps({
   data:{},
   type:null,
   name:'',
   btn_name:{
     type:String,
     default:'DICOM文件上传（上传压缩文件）'
   },
});
// 拿到父级传来的数据
const model = reactive(props.data)
// console.log(model.id,'fields',`${props.type}`,`${props.name}imagesArray`);
// 获取所有的图片，每个文件的值是一个对象，然后放进数组
const images = computed(() => {
 model.fields[`${props.type}`][`${props.name}filesArray`] ?'' :model.fields[`${props.type}`][`${props.name}filesArray`]= []
 return model.fields[`${props.type}`][`${props.name}filesArray`];
});
// console.log(model.fields[`${props.type}`].images,'images');


// --------------------------
// 处理拿到的数据
const arr_obj = (arr)=>{
 const images = []
 arr.forEach((item,index )=> {
   const obj = {}
     obj.name = item
     obj.url =  `${api_host}api/file/get?name=${ item}`
     obj.download = `${api_host}api/file/get?name=${ item}&isZip=false`
     images.push(obj)
 });
 return images
}
const dialogImageUrl = ref('')
// const dialogVisible = ref(false)
const disabled = ref(false)

// 上传图片
const upload =async (file)=>{
 // 防止名字重复加唯一标识(加在了后端)
 
   // 判断文件是否存在
   // let upload_not = await common.upload_not(file.file.name)
   // 检查文件是否可以上传
   // if(upload_not.result != "success") {
   //   ElMessage.error(upload_not.msg)
   //   return
   // }
   // if(!upload_not.data.isAllowUpload) {
   //   ElMessage.error(upload_not.msg)
   //   return 
   // }


   let formdata = new FormData()
   formdata.append('file',file.file)
   formdata.append('id',model.id)
   formdata.append('path',`${props.type}.${props.name}filesArray`)
   progressFlog.value = true

   const upload = async (formdata)=>{
     let uploadPercent = null
     const res = await axios({
       method: 'post',
       url: `${api_host}api/file/upload`,
       data: formdata,
       timeout:0,
       onUploadProgress: (progressEvent_1) => {
         // 计算上传进度百分比
         uploadPercent = Math.round((progressEvent_1.loaded * 100) / progressEvent_1.total)
         loadProgress.value = uploadPercent
       }
     })
     return res.data
   }
   // 返回的是一个promise对象
   let res = await upload(formdata)
   if(res.result == 'success'){
       model.fields[`${props.type}`][`${props.name}filesArray`]?.push(res.data.name)
       progressFlog.value = false
       loadProgress.value =0
   }else{
       ElMessage.error(res.msg)
   }
};
 // 预览(禁掉)
const handlePictureCardPreview = (url) => {
   dialogImageUrl.value = url.url
  //  dialogVisible.value = true
};
   // 下载图片(无压缩)
const downloadImage =async (e)=> {
    // 获取图片对象和画布对象
    const imgUrl = e?.download
    const response = await fetch(imgUrl)
    const blob = await response.blob()
    // 创建下载链接
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = e?.name
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    // 释放 Blob URL
    window.URL.revokeObjectURL(url)
};
 //  删除图片
const handleRemove = (e,index)=>{
 // id=${id}&path=${path}&index=${index}

 ElMessageBox.confirm(
   '确定要删除此文件吗？',
   'Warning',
   {
     confirmButtonText: '确定',
     cancelButtonText: '取消',
     type: 'warning',
   }
 ).then(async () => {
     let pic_del = await common.pic_del(e.name,model.id,`${props.type}.${props.name}filesArray`,index)
     console.log(pic_del,"del 返回")
     if (pic_del.result == 'success'){
       model.fields[`${props.type}`][`${props.name}filesArray`]?.splice(index,1)
     } else{
       ElMessage.error('删除失败！')
     }
   })
};

</script>

<style lang="scss" scoped> 
.demoimgs{
  width: 100%;
   padding: 2px;
   margin-top:30px;
   .imgs{
    position: relative;
    width: 100%;
     p{
      margin: 15px 0 30px;
     }
     .icons{
      background-color: rgba(0,0, 0, 0.4);
      justify-content:space-around;

       display: flex;
       width: 200px;
       top: 6px;
       position: absolute;
       z-index:10;
       .icon{
         font-size: 18px;
         color: white;
       }
       span{
        cursor: pointer;
       }
     }
   }
   //无用
   .imgs:hover .icons1 {
       background-color: rgba(0,0, 0, 0.4);
        //  width: 36px;
      //  height: 36px;
         display: flex;
        //  flex-direction: column;
        //  align-items: center;
         justify-content:space-around;
     }
}
.Preview{
 width: 100%;
 height: 100%;
}
.btn_fiexd{
 margin-left:10px;
 margin-top:21px;
}
.blue_btn{
        background-color: rgb(84, 84, 241);
        border: 0 solid rgb(35, 35, 239);
    }
</style>